import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

import { PromoPageContent } from './promo.models';

@Injectable({
    providedIn: 'root',
})
export class PromoPageDomManipulatorService {
    promoAssetAttributeName: string = 'data-promo-asset';

    constructor(
        private titleService: Title,
        private metaService: Meta,
    ) {}

    manipulateDom(promoPageContent: PromoPageContent): void {
        this.setHtmlTitle(promoPageContent.Title);

        this.setPageDescription(promoPageContent.PageDescription);

        this.setBodyClass(promoPageContent.BodyClass);

        this.removeCustomAssets();

        this.addProductGlobalJavascriptVariable(promoPageContent.Product);

        this.addAssets(promoPageContent.AssetManagementHead, promoPageContent.AssetManagementBottom);
    }

    setHtmlTitle(title: string): void {
        if (title) {
            this.titleService.setTitle(title);
        }
    }
    setPageDescription(description: string): void {
        if (description) {
            this.metaService.updateTag({ name: 'description', content: description });
        }
    }

    setBodyClass(bodyClass: string): void {
        if (bodyClass) {
            document.body.className = bodyClass;
        }
    }

    removeCustomAssets(): void {
        const elementsToRemove: any = this.getAllElementsWithAttribute(this.promoAssetAttributeName);
        for (let i: any = 0; i < elementsToRemove.length; i++) {
            const element: any = elementsToRemove[i];

            if (element.parentNode) {
                element.parentNode.removeChild(element);
            }
        }
    }

    addProductGlobalJavascriptVariable(product: string): void {
        if (!product) {
            return;
        }

        const productScript: any = this.createScriptTag();

        productScript.innerHTML = "var gPluginsPromoProduct = '" + this.escapeHtml(product) + "';";

        this.appendElement(document.head, productScript);
    }

    addScriptPageAssetHeader(scriptElement: string): void {
        if (!scriptElement) {
            return;
        }
        const prepareScriptElement: any = this.createScriptTag();
        prepareScriptElement.innerHTML = this.escapeHtml(scriptElement);
        this.appendElement(document.head, prepareScriptElement);
    }

    addStylePageAssetHeader(styleElement: string): void {
        if (!styleElement) {
            return;
        }
        const prepareStyleElement = this.createStyleTag();
        let embeddedHTMLWithCssSymbols = this.escapeHtml(styleElement);
        prepareStyleElement.innerHTML = embeddedHTMLWithCssSymbols.replaceAll(' &gt; ', ' > ');
        this.appendElement(document.head, prepareStyleElement);
    }

    addAssets(headerHtml: any, footerHtml: any): void {
        this.appendElements(document.head, headerHtml);

        this.appendElements(document.body, footerHtml);
    }

    appendElements(parentNode: any, html: any): void {
        if (!html) {
            return;
        }

        const wrapper: any = document.createElement('div');
        wrapper.innerHTML = html;
        const elements: any = wrapper.childNodes;

        let elementToAdd: any;

        for (let i: any = 0; i < elements.length; i++) {
            const element: any = elements[i];

            if (this.isInvalidElementToAdd(element)) {
                continue;
            }

            if (element.nodeName === 'SCRIPT') {
                elementToAdd = this.createScriptTagFromNode(element);
            } else {
                elementToAdd = element.cloneNode(true);
            }

            this.appendElement(parentNode, elementToAdd);
        }
    }

    createScriptTagFromNode(element: any): HTMLScriptElement {
        const script: HTMLScriptElement = this.createScriptTag();
        if (element.src) {
            script.src = element.src;
        }

        if (element.text && element.text.trim() !== '') {
            script.text = element.text;
        }
        if (element.type) {
            script.type = element.type;
        }

        return script;
    }

    appendElement(containerNode: any, elementToAdd: any): void {
        if (elementToAdd.setAttribute) {
            elementToAdd.setAttribute(this.promoAssetAttributeName, '');
            elementToAdd.setAttribute('name', this.promoAssetAttributeName);
        }
        containerNode.appendChild(elementToAdd);
    }

    isInvalidElementToAdd(element: any): boolean {
        return element.nodeType !== 1;
    }

    createScriptTag(): HTMLScriptElement {
        const script: HTMLScriptElement = document.createElement('script');
        script.type = 'text/javascript';
        return script;
    }

    createStyleTag(): HTMLStyleElement {
        const style: HTMLStyleElement = document.createElement('style');
        return style;
    }
    escapeHtml(str: string): string {
        const div: HTMLDivElement = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
    }

    getAllElementsWithAttribute(attribute: string): Element[] {
        const matchingElements: any[] = [];
        const allElements: any = document.getElementsByTagName('*');
        for (let i: any = 0, n: any = allElements.length; i < n; i++) {
            if (allElements[i].getAttribute(attribute) !== null) {
                // element exists with attribute. Add to array.
                matchingElements.push(allElements[i]);
            }
        }
        return matchingElements;
    }
}
